export class UrlHelper {
  parseToUrlParams(target: any, prefix: string): string {
    var str = "";
    for (var key in target) {
      const value = target[key];
      if (value === null || value === undefined) {
        continue;
      }
      if (str != "") {
        str += "&";
      }
      str += (prefix + key) + "=" + encodeURIComponent(value);
    }

    return '?' + str;
  }

}
